export const GOALS_ACTIONS = {
  LOAD_ROOT_OBJECTIVES: "LOAD_ROOT_OBJECTIVES",
  LOAD_BRANCH_OBJECTIVES: "LOAD_BRANCH_OBJECTIVES",
  SET_LOADING: "SET_LOADING",
  SET_ERROR: "SET_ERROR",
};
